import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { IAdminxStore } from '../../stores';

export const useDestinations = () => {
	const { campaignStore } = useStores<IAdminxStore>();
	const campaign = campaignStore.getCrud().getData();
	const advertiserId =
		campaign.getAdvertiser()?.getId() ??
		campaign.getCampaignDestinations()[0]?.destination_dto?.advertiser?.id ??
		campaign.campaign_destination?.destination_dto?.advertiser?.id;

	useEffect(() => {
		campaignStore.getDestinations().fetch(advertiserId);
	}, [advertiserId]);

	return {
		error: campaignStore.getDestinations().getError(),
		isLoading: campaignStore.getDestinations().getIsLoading(),
	};
};
